import { useTranslation } from "react-i18next";
import RobinPage from "../components/RobinPage";
import {
  useDeletePlanMutation,
  useGetAllPlansQuery,
} from "../graphql/generated/hooks";
import { Button, message, Space, Table, Typography } from "antd";
import EditDeleteActions from "../components/EditDeleteActions";
import { useNavigate } from "react-router-dom";
import { ReloadOutlined } from "@ant-design/icons";

function PlanList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const { data, loading, refetch } = useGetAllPlansQuery();
  const [deletePlan, { loading: deleting }] = useDeletePlanMutation();
  const dataSource = data?.getAllPlans?.map((plan, index) => ({
    key: index,
    name: plan.name,
    actions: (
      <EditDeleteActions
        onEdit={() => {
          navigate(`/settings/plans/mutate/${plan.id}`, {
            state: { plan },
          });
        }}
        onDelete={() => {
          deletePlan({ variables: { id: plan.id } })
            .then(() => {
              messageApi.success(t("message.success.data_deleted"));
              refetch();
            })
            .catch((error) => {
              messageApi.error(t("message.error.data_delete_failed"));
              console.error(error);
            });
        }}
        loadingDelete={deleting}
      />
    ),
  }));

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    { title: "Actions", dataIndex: "actions", key: "actions" },
  ];
  return (
    <RobinPage
      title={t("label.menu.plans")}
      actions={
        <Space size="large">
          <Typography.Link
            onClick={() => {
              refetch();
            }}
          >
            <ReloadOutlined />
          </Typography.Link>
          <Button
            onClick={() => {
              navigate("/settings/plans/mutate");
            }}
          >
            {t("button.add")}
          </Button>
        </Space>
      }
    >
      {contextHolder}
      <Table loading={loading} dataSource={dataSource} columns={columns} />
    </RobinPage>
  );
}

export default PlanList;
